import React from "react";
import { useAppContext } from "@qpr/client-api-base/context/AppCtxProvider";
import useLink from "@qpr/client-api-base/hooks/useLink";
import typeToView from "routing/typetoview";
import useHierarchy from "backend/hooks/elements/useHierarchy";
import useElement from "backend/hooks/elements/useElement";
import StrategyToolbar from "components/toolbars/StrategyToolbar";
import Page from "design/pages/Page";
import useBySymbol from "backend/hooks/elements/useBySymbol";
import StrategyGridWithThemes from "design/components/tables/StrategyGridWithThemes";
import flattenHierarchy from "backend/flattenHierarchy";
import useScorecardTopElement from "backend/hooks/model/useScorecardTopElement";
import { getFileApiURL } from "@qpr/client-api-base/utils/url-utils";
import PageContainer from "design/layouts/PageContainer";

const StrategyMap = () => {
  const ctx = useAppContext();

  const { data: root } = useScorecardTopElement("L0");

  const link = useLink();
  const {
    data,
    isLoading: isDataLoading,
    isError,
    isPreviousData,
    isRefetching,
  } = useHierarchy(ctx.elementId || root?.id);

  const { data: theme } = useBySymbol("D0_T");
  const { data: themeHierarchy, isLoading: isThemesLoading } = useHierarchy(
    theme?.id
  );

  return (
    <Page
      isLoading={
        !data || isDataLoading
        /*
        isRefetching ||
        isPreviousData ||
        isThemesLoading ||
        !themeHierarchy
        */
      }
      Toolbar={StrategyToolbar}
    >
      <PageContainer>
        <StrategyGridWithThemes
          primaryThemeColors={["#00AEC7E3", "#FDDA25E3", "#00843DE4"]}
          primaryThemeTextColors={["#fff", "#000", "#fff"]}
          defaultThemeColor="#888a"
          elementBgImages={[
            getFileApiURL("/images/divisions/financial.png"),
            getFileApiURL("/images/divisions/market.png"),
            getFileApiURL("/images/divisions/process.png"),
            getFileApiURL("/images/divisions/enablers.png"),
          ]}
          elements={
            data?.sort((a, b) => a.symbol.localeCompare(b.symbol)) || []
          }
          themes={(themeHierarchy || [])
            .sort((a, b) => a.symbol.localeCompare(b.symbol))            }
          onSelect={(el) => {
            link({ page: typeToView(el.typename), meaId: el.id });
          }}
        />
      </PageContainer>
    </Page>
  );
};
export default StrategyMap;
